;(function () {
	const idMenuToInjectBanner = [120, 36, 80]

	if (~idMenuToInjectBanner.indexOf(WC.idMenu) && WC.idArticolo) {
		injectBanner()
	}

	function injectBanner() {
		const emailTo = 'fotoitinerari@asiago.it'

		const socialshare = document.querySelector('.body-page .share')
		const banner = document.createElement('div')
		socialshare.parentNode.insertBefore(banner, socialshare.nextSibling)

		banner.classList.add('syfb')

		banner.innerHTML = `
		<div class="syfb__picture">
			<img src="/images/itinerari/syfb_background.jpg" alt="" class="syfb__image">
		</div>
		<div class="syfb__text">
			<div class="syfb__logobox">
				<i class="syfb__icon material-icons">photo_camera</i>
				<p class="syfb__title">${sml('title')}</p>
			</div>
			<div class="syfb__header">
				<div class="syfb-header__left">
					<ul class="syfb-list">
						<li class="syfb-item">
							<span class="syfb-text1">${sml('step1title')}</span>
							<span class="syfb-text2">${sml('step1desc')}</span>
						</li>
						<li class="syfb-item">
							<span class="syfb-text1">${sml('step2title')}</span>
							<span class="syfb-text2">${sml('step2desc')}</span>
						</li>
						<li class="syfb-item">
							<span class="syfb-text1">${sml('step3title')}</span>
							<span class="syfb-text2">${sml('step3desc')}</span>
						</li>
					</ul>
				</div>
				<div class="syfb-header__right">
					<span class="syfb__buttons-intro">${sml('buttonsIntro')}</span>
					<div class="syfb__buttons">
						<a href="mailto:${emailTo}?subject=${sml('emailSubject')}&body=${sml(
			'emailBody'
		)}" target="_blank" title="${sml('emailTitle')}" class="syfb-button syfb-button--email">
							<i class="syfb__email-icon material-icons">mail</i>
							<span class="syfb__email-text">${sml('emailText')}</span>
						</a>
						<a href="https://wetransfer.com/?lang=${WC.lang.substring(0, 2)}&to=${emailTo}&msg=${sml(
			'wetransferMsg'
		)}" target="_blank" rel="noopener nofollow" title="${sml(
			'wetransferTitle'
		)}" class="syfb-button syfb-button--wetransfer">
							<img src="/images/itinerari/logo_wetransfer-white.svg" alt="WeTransfer Logo" class="syfb__wetransfer-logo">
						</a>
					</div>
				</div>
			</div>
			<div class="syfb__description">
				<p class="syfb__copy">${sml('description')}</p>
			</div>
		</div>`
	}

	function sml(string) {
		const strings = {
			title: {
				it: 'Scatta & Condividi!',
				en: 'Take a picture & share!',
				de: 'Mach ein Foto & teile es',
			},
			step1title: {
				it: 'Scatta le foto',
				en: 'Take pictures',
				de: 'Nehmen Sie Bilder auf',
			},
			step1desc: {
				it: "Mentre percorri l'itinerario",
				en: 'As you go along the route',
				de: 'Wie gehst du entlang der Strecke',
			},
			step2title: {
				it: 'Invia le foto',
				en: 'Send photos',
				de: 'Senden Sie Fotos',
			},
			step2desc: {
				it: 'Indicando data, luogo e autore dello scatto',
				en: 'Indicating date, place and author of the shot',
				de: 'Angabe von Datum, Ort und Autor der Aufnahme',
			},
			step3title: {
				it: 'Le foto migliori',
				en: 'The best photos',
				de: 'Die besten Fotos',
			},
			step3desc: {
				it: 'Verranno pubblicate su questa pagina',
				en: 'They will be published on this page',
				de: 'Sie werden auf dieser Seite veröffentlicht',
			},
			buttonsIntro: {
				it: 'Invia tramite:',
				en: 'Send via:',
				de: 'Senden Sie über:',
			},
			emailTitle: {
				it: 'Inviaci le tue foto tramite email',
				en: 'Send us your photos by email',
				de: 'Senden Sie uns Ihre Fotos per E-Mail',
			},
			emailText: {
				it: 'Email',
				en: 'Email',
				de: 'Email',
			},
			emailSubject: {
				it: encodeURI('Invio foto scattate su itinerario: (nome itinerario)'),
				en: encodeURI('Sending photos taken on itinerary: (itinerary name)'),
				de: encodeURI(
					'Senden von Fotos, die auf der Reiseroute aufgenommen wurden: (Name der Reiseroute)'
				),
			},
			emailBody: {
				it: encodeURI(
					'Autore scatto: (nome), Luogo scatto: (nome), Data scatto: (giorno, mese, anno)'
				),
				en: encodeURI(
					'Shooting author: (name), Place of shooting: (name), Date taken: (day, month, year)'
				),
				de: encodeURI(
					'Aufnahmeautor: (Name), Aufnahmeort: (Name), Aufnahmedatum: (Tag Monat Jahr)'
				),
			},
			wetransferMsg: {
				it: encodeURI(
					'Invio foto scattate su itinerario: (nome itinerario). Autore scatto: (nome), Luogo scatto: (nome), Data scatto: (giorno, mese, anno)'
				),
				en: encodeURI(
					'Sending photos taken on itinerary: (itinerary name). Shooting author: (name), Place of shooting: (name), Date taken: (day, month, year)'
				),
				de: encodeURI(
					'Senden von Fotos, die auf der Reiseroute aufgenommen wurden: (Name der Reiseroute). Aufnahmeautor: (Name), Aufnahmeort: (Name), Aufnahmedatum: (Tag Monat Jahr)'
				),
			},
			wetransferTitle: {
				it: 'Inviaci le tue foto tramite WeTransfer',
				en: 'Send us your photos via WeTransfer',
				de: 'Senden Sie uns Ihre Fotos per WeTransfer',
			},
			description: {
				it: '',
				en: '',
				de: '',
			},
		}

		return strings[string][WC.lang.substring(0, 2)]
	}
})()
